import { render } from "./Gamephase.vue?vue&type=template&id=eab3529e&scoped=true"
import script from "./Gamephase.vue?vue&type=script&lang=js"
export * from "./Gamephase.vue?vue&type=script&lang=js"

import "./Gamephase.vue?vue&type=style&index=0&id=eab3529e&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eab3529e"]])

export default __exports__